(function () {
  if (window.bqTooltipInit) return;
  window.bqTooltipInit = true;

  var tip = document.createElement('div');
  tip.className = 'bq-tip';
  tip.setAttribute('role', 'tooltip');
  var current = null;

  function ready() { document.body.appendChild(tip); }
  if (document.body) { ready(); }
  else { document.addEventListener('DOMContentLoaded', ready); }

  function place(el) {
    var r = el.getBoundingClientRect();
    var t = tip.getBoundingClientRect();
    var x = r.left + r.width / 2 - t.width / 2;
    var y = r.top - t.height - 8;
    if (y < 6) { y = r.bottom + 8; }
    if (x < 6) { x = 6; }
    if (x + t.width > window.innerWidth - 6) { x = window.innerWidth - t.width - 6; }
    tip.style.left = Math.round(x) + 'px';
    tip.style.top = Math.round(y) + 'px';
  }

  // Migrate title to data-bq-title to disable the native tooltip.
  function arm(el) {
    if (el.hasAttribute('title')) {
      var v = (el.getAttribute('title') || '').trim();
      if (v) { el.setAttribute('data-bq-title', v); }
      el.removeAttribute('title');
    }
  }

  function show(el) {
    var text = el.getAttribute('data-bq-title');
    if (!text) return;
    tip.textContent = text;
    tip.style.left = '-9999px';
    tip.style.top = '0';
    tip.setAttribute('data-show', '');
    place(el);
    current = el;
  }

  function hide() {
    tip.removeAttribute('data-show');
    current = null;
  }

  // Delegation: also covers content injected later.
  document.addEventListener('mouseover', function (e) {
    var el = e.target.closest ? e.target.closest('[title], [data-bq-title]') : null;
    if (!el) return;
    arm(el);
    if (el !== current) show(el);
  });

  document.addEventListener('mouseout', function (e) {
    if (!current) return;
    var el = e.target.closest ? e.target.closest('[data-bq-title]') : null;
    if (el && el === current) hide();
  });

  document.addEventListener('focusin', function (e) {
    var el = e.target.closest ? e.target.closest('[title], [data-bq-title]') : null;
    if (!el) return;
    arm(el);
    show(el);
  });

  document.addEventListener('focusout', hide);
  window.addEventListener('scroll', function () { if (current) hide(); }, true);
})();
